/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { DateTimeTypes } from '@gh/common-shared';
import { buildDateTimeColumn, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';

@Injectable()
export class XeroIssueLogGridDefinitionService extends LayoutBasedGridDefinition {
  buildColumnDefs(): Hash<ColDef> {
    return {
      issueDate: buildDateTimeColumn(DateTimeTypes.Timestamp),
    };
  }

  buildGridOptions(): GridOptions {
    return { getRowId: (params) => String(params.data.id)};
  }
}
